'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import Linkify from 'react-linkify';
import {TimeAgo} from '../../../components/temporal/TimeAgo';
import {AvatarImage} from '../../../files/components/AvatarImage';


const linkifyProps = {
  target: '_blank',
};

export function ChatTextItemView(props) {
  return (
    <div
      className={classNames("ChatTextItem", props.className, {
        ChatTextItem_sent: props.isAuthor,
      })}
    >
      <AvatarImage
        className="ChatTextItem__initial"
        iconClass="Avatar__largeIcon"
        avatarInitials={props.senderInitial}
        title={props.sender}
        avatarColor={props.avatarColor}
        avatarFontColor={props.avatarFontColor}
        requiresAuth={props.avatarRequiresAuth}
        url={props.avatarUrl}
        displayWidth={50}
        displayHeight={50}
      />
      <div className="ChatTextItem__timestamp">
        {`${props.sender}, `}
        <TimeAgo date={props.date} />
      </div>
      <div className="ChatTextItem__text">
        <Linkify
          className="ChatTextItem__textContent"
          properties={linkifyProps}
        >
          {renderMessage(props.message, props.callouts)}
        </Linkify>
      </div>
    </div>
  );
}

function renderMessage(message, callouts) {
  if (!callouts) {
    return message;
  } else {
    const list = [];
    let previousIdx = 0;
    let currentIdx = 0;
    for (let i = 0, len = callouts.length; i < len; i++) {
      currentIdx = callouts[i].idx;
      if (currentIdx - previousIdx > 0)
        list.push(message.substr(previousIdx, currentIdx));

      list.push(
        <span
          key={callouts[i].idx}
          className="ChatTextItem__callout"
        >
          {callouts[i].token}
        </span>
      );

      previousIdx = currentIdx + callouts[i].token.length;
    }

    currentIdx = message.length;
    if (currentIdx - previousIdx > 0)
      list.push(message.substr(previousIdx, currentIdx));

    return list;
  }
}

ChatTextItemView.propTypes = {
  className: T.string,
  isAuthor: T.bool,
  message: T.string,
  date: TimeAgo.propTypes.date,
  sender: T.string,
  senderInitial: T.string,
  avatarColor: T.string,
  avatarFontColor: T.string,
  avatarUrl: T.string,
  avatarRequiresAuth: T.bool,
};

ChatTextItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatTextItem/ChatTextItemView.js